import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

// Create User API
const userAPI = createApi({
    reducerPath: "userAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        // user management Endpoints

        // Get All users list
        getUsers: builder.mutation({
            query: (userQuery) => ({
                url: '/User/GetUsersList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //Add User
        addUser: builder.mutation({
            query: (data) => ({
                url: `/User/AddUser`,
                method: 'POST',
                body: transformRequest(data),
            }),
            // invalidateTags: ['addUser'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Query to get User by Id
        getUserById: builder.query({
            query: (userId) => ({
                url: `/User/GetUserDetailByUserId/?userId=${Number(userId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Update User
        updateUser: builder.mutation({
            query: (userDetails) => ({
                url: '/User/UpdateUserByUserId',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getCheckUser: builder.query({
            query: (UserName) => ({
                url: `/User/CheckUserNameExist?UserName=${UserName}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteUser: builder.mutation({
            query: (details) => ({
                url: `/User/DeleteUser/?userId=${details}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllUser: builder.query({
            query: () => ({
                url: `/User/GetAllUser`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateUserByStatus: builder.mutation({
            query: (userDetails) => ({
                url: '/User/UpdateUserByStatus',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllUserTLAndAdmin: builder.query({
            query: () => ({
                url: '/User/GetAllUserTLAndAdmin',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

       
    })
});

// Extract hooks for easy access to various API requests 
export const {
    useGetUsersMutation,
    useAddUserMutation,
    useLazyGetUserByIdQuery,
    useUpdateUserMutation,
    useDeleteUserMutation,
    useLazyGetCheckUserQuery,
    useLazyGetAllUserQuery,
    useUpdateUserByStatusMutation,
    useLazyGetAllUserTLAndAdminQuery
} = userAPI;

export default userAPI;